import React from "react";
import Home from "../pages/Home";
import ConnexityProducts from "../pages/ConnexityProducts";
import ProductDetail from "../pages/ProductDetail";
import {LEGAL_PAGES} from "../constants";

const About = React.lazy(() => import("../pages/About"));
const Legal = React.lazy(() => import("../pages/Legal"));

const routeConfig =  [
    {
        path: '*',
        element: <Home/>,
    },
    {
        path: '/product/:productId',
        element: <ProductDetail/>,
    },
    {
        path: '/lpv/connexity-related-products/',
        element: <ConnexityProducts/>,
    },
    {
        path: '/about/',
        element: <About/>,
    },
    {
        path: `/${LEGAL_PAGES.PRIVACY.link}/`,
        element: <Legal typeObj={LEGAL_PAGES.PRIVACY}/>,
    },
    {
        path: `/${LEGAL_PAGES.TERMS.link}/`,
        element: <Legal typeObj={LEGAL_PAGES.TERMS}/>,
    },
    {
        path: `/${LEGAL_PAGES.COOKIE.link}/`,
        element: <Legal typeObj={LEGAL_PAGES.COOKIE}/>,
    }
]

export default routeConfig;
